import { Relationship } from '@celito.clients/types';
import { useGetInboundRelationship } from 'apps/web-client/src/screens/Platform/admin-ui-screen/services/inbound-relationship';
import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import { useEffect, useState } from 'react';

import { StateOfRelatedObjectsProps } from './state-of-related-objects.model';
import { StateOfRelatedObjectsView } from './state-of-related-objects.view';

export const StateOfRelatedObjectsController = (
  props: StateOfRelatedObjectsProps
) => {
  const { data: inboundRelationship, isLoading: isInboundLoading } =
    useGetInboundRelationship(props.objectName);

  const [appObjects, setAppObjects] = useState<IOption[]>([]);

  const transformComplexName = (name: string) => {
    // Split by double underscores and take all parts except the last one
    const relevantPart = name.split('__').slice(0, -1).join('__');

    // Replace underscores with spaces and convert to title case
    const titleCased = relevantPart
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');

    return titleCased;
  };

  useEffect(() => {
    if (!isInboundLoading && inboundRelationship) {
      const relationships: Relationship[] = [
        ...inboundRelationship,
        ...(props?.objectData?.relationships || []),
      ];

      const appObjects = relationships.map((item) => {
        return {
          value: item.objectName,
          text: transformComplexName(item.objectName),
          data: { ...item },
        };
      });

      setAppObjects(appObjects);
    }
  }, [inboundRelationship, isInboundLoading, props?.objectData?.relationships]);

  const comparisonOptions: IOption[] = [
    { text: 'All Records State Equal', value: 'AllRecordsStateEqual' },
    { text: 'No Records State Equal', value: 'NoRecordsStateEqual' },
    {
      text: 'At Lest One Record State Equal',
      value: 'AtLeastOneRecordStateEqual',
    },
  ];

  return (
    <StateOfRelatedObjectsView
      {...{ ...props, appObjects, isInboundLoading, comparisonOptions }}
    />
  );
};
